var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "my-3" }, [
    _c("h5", [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    !_vm.isDataEmpty
      ? _c(
          "div",
          [
            _c("v-client-table", {
              ref: "tagsTable",
              staticClass:
                "w-100 vue-custom-table no-pagination document-tags-table no-head-table scrollable-table",
              attrs: {
                data: _vm.data,
                columns: _vm.columns,
                options: _vm.options,
                name: "manageTagsTable",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "preview",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "b-badge",
                          {
                            staticClass: "m-0",
                            style: {
                              backgroundColor: row.colour,
                              color: _vm.getTextColor(row.colour),
                            },
                            attrs: { pill: "" },
                          },
                          [
                            _vm._v(
                              "\n          " + _vm._s(row.name) + "\n        "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "delete",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-end align-items-center",
                            class: { disabled: _vm.isLoading(row) },
                          },
                          [
                            !_vm.isEditing(row)
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "text-primary mr-2 clickable",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showRowChild(row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("global.words.edit")))]
                                )
                              : _c(
                                  "simple-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      "class-name": "btn-sm",
                                      disabled: _vm.isInvalid(row),
                                      loading: _vm.isLoading(row),
                                      "loading-succeeded":
                                        _vm.editing[row.id].loadingSucceeded,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEdit(row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("global.words.save")) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                            _vm._v(" "),
                            !_vm.isDeleting(row)
                              ? _c("inline-prompt", {
                                  staticClass:
                                    "d-inline-block bold text-gray ml-2",
                                  attrs: {
                                    placement: "left",
                                    "action-type": "delete",
                                    "confirmation-text": _vm.$t(
                                      "documents.deleteDocumentTypeConfirmation"
                                    ),
                                  },
                                  on: {
                                    accept: function ($event) {
                                      return _vm.handleRemove(row)
                                    },
                                  },
                                })
                              : _c("inline-loader", {
                                  staticClass: "ml-2",
                                  attrs: {
                                    width: "16px",
                                    height: "16px",
                                    variant: "danger",
                                  },
                                }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "child_row",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "b-row",
                          { class: { disabled: _vm.isLoading(row) } },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "5" } },
                              [
                                _c("material-input", {
                                  staticClass: "mb-0",
                                  attrs: {
                                    "on-type": "",
                                    label: _vm.$t("global.words.name"),
                                  },
                                  on: {
                                    input: function (value) {
                                      return _vm.preEditLabel(
                                        Object.assign({}, row, { name: value })
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.editing[row.id].name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.editing[row.id], "name", $$v)
                                    },
                                    expression: "editing[row.id].name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "theme-colorpicker",
                                attrs: { cols: "5" },
                              },
                              [
                                _c("colorpicker", {
                                  staticClass: "b-0",
                                  attrs: { color: _vm.editing[row.id].colour },
                                  on: {
                                    change: function ($event) {
                                      return _vm.preEditColourLabel(
                                        Object.assign({}, row, {
                                          colour: $event,
                                        })
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass:
                                  "d-flex justify-content-end align-items-center",
                                attrs: { cols: "2" },
                              },
                              [
                                _c("icon", {
                                  staticClass: "clickable",
                                  attrs: { name: "ban" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.restoreChanges(row)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                1123623575
              ),
            }),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "d-flex flex-column align-items-center w-100" },
          [
            _c(
              "no-results",
              {
                attrs: {
                  "img-src": require("@Shared/@Assets/img/application-missing.png"),
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("documents.thereAreCurrentlyNoLabels")) +
                    "\n    "
                ),
              ]
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }